export interface Membership {
  createdDate: string;
  docuSignStatus: {
    date: string;
  };
  product: {
    family: string;
    id: string;
    name: string;
  };
  projectName: string;
  systemModStamp: string;
  accountId: string;
  agreementDate: string;
  annualFullPrice: string;
  assetLevel: number;
  autoRenew: boolean;
  cancellationDate: string;
  endDate: string;
  id: string;
  installDate: string;
  name: string;
  numberOfYearsRequired: number;
  order: number;
  paymentFrequency: string;
  paymentTerms: string;
  price: number;
  projectId: string;
  purchaseDate: string;
  quantity: number;
  renewalType: string;
  rootAssetId: string;
  status: string;
  year: string;
}
